export default {
      id: "access-is-denied-usage",
      viewBox: "0 0 1280 1280",
      url: __webpack_public_path__ + "img/icons.svg#access-is-denied",
      toString: function () {
        return this.url;
      }
    }